import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { initTracking, captureAttribution, track } from "../lib/tracking";

const SiteContext = createContext({});
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [exams, setExams] = useState([]);

  useEffect(() => {
    captureAttribution();
    (async () => {
      try {
        const [s, t, e] = await Promise.all([
          api.get("/site-settings"),
          api.get("/tracking-settings"),
          api.get("/exams"),
        ]);
        setSettings(s.data || {});
        setExams(e.data || []);
        initTracking(t.data);
        track("PageView");
        if (s.data?.brand_name) document.title = `${s.data.brand_name} — Online Test Series`;
      } catch (err) {}
    })();
  }, []);

  return <SiteContext.Provider value={{ settings, exams }}>{children}</SiteContext.Provider>;
}
